var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "32px",
    viewBox: "0 0 25 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital-Settlements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-page---Go-to-Digital-settlements---insurance-widget-Copy",
    transform: "translate(-607, -1813)",
    fill: "#D14200",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-trash",
    transform: "translate(607, 1813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375,0 L7.8125,1.5625 L0,1.5625 L0,4.6875 L1.5625,4.6875 L1.5625,28.125 C1.5625,28.9409719 1.86145141,29.7728281 2.45056156,30.3619391 C3.03967172,30.9510484 3.87152781,31.25 4.6875,31.25 L20.3125,31.25 C21.1284719,31.25 21.9603281,30.9510484 22.5494391,30.3619391 C23.1385484,29.7728281 23.4375,28.9409719 23.4375,28.125 L23.4375,4.6875 L25,4.6875 L25,1.5625 L17.1875,1.5625 L15.625,0 L9.375,0 Z M4.6875,4.6875 L20.3125,4.6875 L20.3125,28.125 L4.6875,28.125 L4.6875,4.6875 Z M7.8125,7.8125 L7.8125,25 L10.9375,25 L10.9375,7.8125 L7.8125,7.8125 Z M14.0625,7.8125 L14.0625,25 L17.1875,25 L17.1875,7.8125 L14.0625,7.8125 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2adf5a2915f674331d9a3fa73efa2124.svg";
export { ForwardRef as ReactComponent };